import React from 'react';
import { useHistory } from 'react-router-dom';
import { Mui, MuiIcons } from '@leap4/frontend';

const { Button } = Mui;
const { ArrowBack: ArrowBackIcon } = MuiIcons;

interface Props {
    /** Where "back" goes. Always the screen's parent, never wherever the user came from. */
    to: string;
}

/**
 * Back to the parent screen.
 *
 * Deliberately a route rather than history.goBack(): these pages are linked to directly - from
 * the publishers grid, from a bookmark, from a redirect after saving - and going back through
 * history from a deep link leaves the app entirely. Navigating to the known parent always lands
 * somewhere sensible.
 *
 * Always reads "Back" rather than naming the destination: the breadcrumbs beside it already
 * say where you are, and a button whose label changes per screen is one more thing to read.
 */
export const BackButton: React.FC<Props> = ({ to }) => {
    const history = useHistory();

    return (
        <Button
            size="small"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push(to)}
            sx={{ textTransform: 'none' }}
        >
            Back
        </Button>
    );
};
